import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];
var shuffledAnswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}


export default function SpringRe({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac
  //4 = multiple choice 2

  //questions section
  var questionsY1Spring = [];
  questionsY1Spring.push({ "question" : "Aimee has 8 gems. She uses 3 gems. How many are left?", "answer" : "5", "type": 0, "units" : "gems", "marks" : 1})
questionsY1Spring.push({ "question" : "What number is represented below?", "answer" : "27", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "What number is represented below?", "answer" : "14", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "What is the missing number? ", "answer" : "30", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "What is the missing number? ", "answer" : "16", "type": 0, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "Aimee and Emile have both made a number.  Which statement is correct?", "answer" : "Emile's number is greater than Aimee's number. |Emile's number is less than Aimee's number. |Emile's number is equal to Aimee's number. ", "type": 1, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "Which is heaviest? ", "answer" : "The red gem|The blue gem", "type": 4, "units" : "", "marks" : 1})
questionsY1Spring.push({ "question" : "Scrambler has 14 gems. He uses 3 gems. How many are left?", "answer" : "11", "type": 0, "units" : "gems", "marks" : 1})
questionsY1Spring.push({ "question" : "What number is A?", "answer" : "25", "type": 0, "units" : "", "marks" : 1})

  


  var questionsY2Spring = [];
  questionsY2Spring.push({ "question" : "Which numbers are ordered from smallest to largest?", "answer" : "21, 27, 32, 41|21, 41, 32, 27|21, 27, 41, 32", "type": 1, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Emile makes two numbers. What is the sum of the two numbers?  ", "answer" : "48", "type": 0, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Scrambler has these coins. He spends 23p. How much money does Scrambler have left? ", "answer" : "35", "type": 0, "units" : "p", "marks" : 1})
  questionsY2Spring.push({ "question" : "Here is a cube. What shape is each face? ", "answer" : "Square|Circle|Cube", "type": 1, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Which shape has 8 vertices? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Emile has counted his gems and made a tally chart. How many blue gems does Emile have? ", "answer" : "6", "type": 0, "units" : "gems", "marks" : 1})
  questionsY2Spring.push({ "question" : "Aimee has counted her gems and made a pictogram. How many red gems does Aimee have? ", "answer" : "9", "type": 0, "units" : "gems", "marks" : 1})
  questionsY2Spring.push({ "question" : "Scrambler is counting in 10s using a number line. He starts at 22 and adds five 10s. At what number will Scrambler finish?", "answer" : "72", "type": 0, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Scrambler is again counting in 10s using a number line. He starts at 22 again but this time he keeps going! Which number will Scrambler say? ", "answer" : "82|26|12", "type": 1, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Using the array shown, ? x 2 = 6", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Using the array shown, ? + 2 = 6", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Which statement is true:  42 ÷ 7 = 6 or 7 ÷ 42 = 6", "answer" : "42 ÷ 7 = 6 is true|7 ÷ 42 = 6 is true|Both 42 ÷ 7 = 6 and 7 ÷ 42 = 6 are true", "type": 1, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Scrambler divides 8 gems into 4 equal piles.  How many gems are in each pile?", "answer" : "2", "type": 0, "units" : "gems", "marks" : 1})
  questionsY2Spring.push({ "question" : "How much of the shape is shaded? ", "answer" : "1/2|1/4|1/3", "type": 1, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Which shape has 3/4 shaded? ", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Emile has circled some gems. What fraction of the gems has Emile circled? ", "answer" : "1/2|1/3|1/4", "type": 1, "units" : "", "marks" : 1})
  questionsY2Spring.push({ "question" : "Aimee has 16 gems. She gives 1/4 of the gems to Emile. How many gems does Aimee have left?  ", "answer" : "12", "type": 0, "units" : "gems", "marks" : 1})
  questionsY2Spring.push({ "question" : "Scrambler has 65 gems. He uses 17 gems on Monday and 24 gems on Tuesday. How many gems doe she have left? ", "answer" : "24", "type": 0, "units" : "gems", "marks" : 1})
  questionsY2Spring.push({ "question" : "Emile has gems organised by colour. He has 16 blue gems, 14 red gems, 3 purple gems, 18 green gems and 15 pink gems.  Emile needs 31 gems. What combination of gems add together to give 31 gems? ", "answer" : "All the blue and pink gems|All the red and green gems|All the purple and green gems. ", "type": 1, "units" : "", "marks" : 1})
  


  var questionsY3Spring = [];
  questionsY3Spring.push({ "question" : "What fraction of the red gems are circled?", "answer" : "6/10|6/4|4/10", "type": 1, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "Below is a rectangle. What is its perimeter?", "answer" : "14", "type": 0, "units" : "cm", "marks" : 1})
questionsY3Spring.push({ "question" : "Five metres is how many centimetres?", "answer" : "500", "type": 0, "units" : "cm", "marks" : 1})
questionsY3Spring.push({ "question" : "Emile has £721. Aimee has £418 less than Emile. How much money does Aimee have? ", "answer" : "303", "type": 0, "units" : "£", "marks" : 1})
questionsY3Spring.push({ "question" : "Emile has £721. Aimee has £418 less than Emile. How much money do they have together? ", "answer" : "1024", "type": 0, "units" : "£", "marks" : 1})
questionsY3Spring.push({ "question" : "Complete the sequence. ", "answer" : "4/5", "type": 2, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "There are three times as many red gems as blue gems. There are 17 blue gems. How many red gems are there? ", "answer" : "51", "type": 0, "units" : "gems", "marks" : 1})
questionsY3Spring.push({ "question" : "Below is a tally chart showing how many of each colour of gem Emile owns. How many Green gems does Emile own?", "answer" : "16", "type": 0, "units" : "gems", "marks" : 1})
questionsY3Spring.push({ "question" : "Here are some coins. How much money is there in total? ", "answer" : "1.37", "type": 0, "units" : "£", "marks" : 1})
questionsY3Spring.push({ "question" : "Emile measures a book. He thinks it is 15cm tall. Aimee thinks it is 1.5m tall. Scrambler thinks the book is 1.5cm tall. Who is most likely to be correct?", "answer" : "Emile|Aimee|Scrambler", "type": 1, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "Complete the part-whole model. ", "answer" : "3/10|7/10|6/10", "type": 1, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "There are 45 gems on Abydos. Emile, Aimee and Scrambler take 5 each. The rest of the gems are stored in 3 tents. How many gems are stored in each tent? ", "answer" : "10", "type": 0, "units" : "gems", "marks" : 1})
questionsY3Spring.push({ "question" : "What number should be used instead of A to make the calculation correct? ", "answer" : "A is 8|A is 2|A is 6", "type": 1, "units" : "", "marks" : 1})
questionsY3Spring.push({ "question" : "Emile has £14.40. He would like to buy 3 red gems and 2 blue gems. How much do the gems cost? ", "answer" : "10.5", "type": 0, "units" : "£", "marks" : 1})
questionsY3Spring.push({ "question" : "Emile has £14.40. He would like to buy 3 red gems and 2 blue gems. How much change does Emile receive?  ", "answer" : "3.9", "type": 0, "units" : "£", "marks" : 1})
questionsY3Spring.push({ "question" : "Emile has 6 red gems and some blue gems. Emile can travel 4 kilometers on a red gem. He can travel 3 kilometers on a blue gem. He travels 51 kilometers. How many blue gems did he have? ", "answer" : "9", "type": 0, "units" : "blue gems", "marks" : 1})




  var questionsY4Spring = [];
  questionsY4Spring.push({ "question" : "Round 16 to the nearest ten.", "answer" : "20", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "Round 163 to the nearest hundred. ", "answer" : "200", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "Round 163 to the nearest ten. ", "answer" : "160", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "What's next in the sequence? ", "answer" : "21/100|20/101|21/10", "type": 1, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "What's next in the sequence? ", "answer" : "0.7|7|0.6", "type": 1, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "Emile has £654. Aimee has £10,000 more than Emile. How much money do they have altogether? ", "answer" : "10654", "type": 0, "units" : "£", "marks" : 1})
  questionsY4Spring.push({ "question" : "There are 8 planets in a newly discovered galaxy. Each planet has the same number of gems. There are 96 gems in total. How many gems are on each planet? ", "answer" : "12", "type": 0, "units" : "gems", "marks" : 1})
  questionsY4Spring.push({ "question" : "In a different galaxy,  there are 14 planets with 8 gems on each planet. Scrambler steals 1/7 of the gems. How many gems does Scrambler steal? ", "answer" : "16", "type": 0, "units" : "gems", "marks" : 1})
  questionsY4Spring.push({ "question" : "There are 72 red gems on the planet Tortuga. There are 7 times as many blue gems as red gems on the planet Tortuga. How many red and blue gems are there altogether on Tortuga?", "answer" : "576", "type": 0, "units" : "gems", "marks" : 1})
  questionsY4Spring.push({ "question" : "What fraction of the shape is shaded?", "answer" : "3/4|9/10|7/8", "type": 1, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "What is 0.7 expressed as a fraction? ", "answer" : "7/10", "type": 2, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "What is 0.07 expressed as a fraction? ", "answer" : "7/100", "type": 2, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "13 ÷ 100 = ?", "answer" : "0.13", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "? ÷ 10 = 6.2", "answer" : "62", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "What is this number? ", "answer" : "3132", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "What is the missing number?  19/9 - 8/9 = 1 + ?/9", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "Complete the statement: 1.2 kilometres is _______ 1,420 metres.", "answer" : "less than |greater than |equal to", "type": 1, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "What is the difference between 1.2 kilometres and 1,420 metres? ", "answer" : "220", "type": 0, "units" : "metres", "marks" : 1})
  questionsY4Spring.push({ "question" : "Which statement is equal to 26 x 8 ?", "answer" : "8 x 13 x 2|4 x 8 x 5|7 x 4 x 8", "type": 1, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "Complete the number sentence: 9  x ? = 7 x 18", "answer" : "14", "type": 0, "units" : "", "marks" : 1})
  questionsY4Spring.push({ "question" : "Scrambler has red, blue and green gems. 7/18 of his gems are red.  5/18 of his gems are blue. He has 12 green gems. How many gems does Scrambler have altogether? ", "answer" : "36", "type": 0, "units" : "gems", "marks" : 1})
  


  var questionsY5Spring = [];
  questionsY5Spring.push({ "question" : "Emile has 273 red gems. He has 88 fewer green gems. How many green gems does Emile have? ", "answer" : "185", "type": 0, "units" : "green gems", "marks" : 1})
questionsY5Spring.push({ "question" : "Aimee has 63 blue and purple gems altogether. 2/7 are blue gems. How many purple gems does Aimee have?", "answer" : "45", "type": 0, "units" : "purple gems", "marks" : 1})
questionsY5Spring.push({ "question" : "What is this number? ", "answer" : "4.53", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "If Emile adds 3 hundredths, what is the new number? ", "answer" : "4.56", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "What is 7,645 rounded to the nearest hundred? ", "answer" : "7600", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "How much of the shape is shaded red? ", "answer" : "3/8|1/4|1/2", "type": 1, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "What is the number A on the number line? ", "answer" : "7/10", "type": 2, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "What is the number B on the number line? ", "answer" : "1/2", "type": 2, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "Pirate hats are £8. Roman soldier helmets are £5. Emile and Aimee buy one pirate hat and two Roman soldier helmet between them. If they split the cost equally, how much will they each pay?", "answer" : "9", "type": 0, "units" : "£", "marks" : 1})
questionsY5Spring.push({ "question" : "Emile buys 4 orange gems for £8. Emile then buys 2 pink gems and 8 orange gems for £22. How much does a pink gem cost?", "answer" : "3", "type": 0, "units" : "£", "marks" : 1})
questionsY5Spring.push({ "question" : "Aimee's book is twice as wide as it is tall. It is 18cm tall. How wide is Aimee's book?", "answer" : "36", "type": 0, "units" : "cm", "marks" : 1})
questionsY5Spring.push({ "question" : "Aimee's book is twice as wide as it is tall. It is 18cm tall. What is the perimeter of Aimee's book? ", "answer" : "108", "type": 0, "units" : "cm", "marks" : 1})
questionsY5Spring.push({ "question" : "Which fraction is not equivalent to 2/3? ", "answer" : "7/10|8/12|10/15", "type": 1, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "Which fraction is equlivalent to 0.77?", "answer" : "77/100|77/10|77/1000", "type": 1, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "Which percentage is equivalent to the fraction 7/100?", "answer" : "7", "type": 0, "units" : "%", "marks" : 1})
questionsY5Spring.push({ "question" : "What fraction of the shape is shaded? ", "answer" : "2/3|2/10|3/6", "type": 1, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "What is 4 3/7 as an improper fraction?", "answer" : "31/7", "type": 2, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "The graph shows the distance travelled by Emile and Aimee each week. In which week, did they travel the furthest? ", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "The graph shows the distance travelled by Emile and Aimee each week. Altogether, how far did Emile and Aimee travel in week 4 and week 5? ", "answer" : "100", "type": 0, "units" : "kilometres", "marks" : 1})
questionsY5Spring.push({ "question" : "Which number statement is true?", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "Which number is a prime number? ", "answer" : "7|6|9", "type": 1, "units" : "", "marks" : 1})
questionsY5Spring.push({ "question" : "Aimee is arranging her gems. A quarter of Aimee's gems are red gems. 3/5 of Aimee's gems are yellow gems. The rest of the gems are blue gems. What percentage of Aimee's gems are blue gems? ", "answer" : "15", "type": 0, "units" : "%", "marks" : 1})
questionsY5Spring.push({ "question" : "Scrambler is weighing his gems. Scrambler has blue and red gems only. Blue gems weigh 4 times as much as a red gem. Blue gems are 72 grams heavier than red gems. What does a red gem weigh? ", "answer" : "24", "type": 0, "units" : "grams", "marks" : 1})




  var questionsY6Spring = [];
  questionsY6Spring.push({ "question" : "Which number is equivalent to 21/100?", "answer" : "0.21", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "What fraction is equivalent to 0.4?", "answer" : "2/5|1/4|4/9", "type": 1, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "Scrambler has made a number on a place value grid. What is Scrambler's number?", "answer" : "5.32", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "Scrambler adds 0.4 to his number. What is Scrambler's new number?", "answer" : "5.72", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "What fraction of the shape is shaded? ", "answer" : "1/10|1/12|2/10", "type": 1, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "Calculate the area of the shape. ", "answer" : "110", "type": 0, "units" : "cm²", "marks" : 1})
questionsY6Spring.push({ "question" : "Calculate the area of the book.", "answer" : "150", "type": 0, "units" : "cm²", "marks" : 1})
questionsY6Spring.push({ "question" : "Calculate the perimeter of the book.", "answer" : "50", "type": 0, "units" : "cm", "marks" : 1})
questionsY6Spring.push({ "question" : "What is the volume of the cuboid? ", "answer" : "96", "type": 0, "units" : "cm³", "marks" : 1})
questionsY6Spring.push({ "question" : "Aimee has some gems. For every 3 red gems, Aimee has 4 blue gems. Aimee has 12 red gems. How many blue gems does Aimee have? ", "answer" : "16", "type": 0, "units" : "red gems", "marks" : 1})
questionsY6Spring.push({ "question" : "The numbers in the sequence below increase by the same amount each time. What number should replace A? ", "answer" : "22", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "The numbers in the sequence below increase by the same amount each time. What number should replace B? ", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "Which of these numbers is a prime number <b>and</b> a factor of 42?", "answer" : "7|5|9", "type": 1, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "Emile has some pink gems and green gems. He has 4 times as many green gems as pink gems. He has 12 more green gems than pink gems. How many gems does Emile have altogether? ", "answer" : "20", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "Aimee has counted her gems and made a table. How many blue and red gems does she have? ", "answer" : "18", "type": 0, "units" : "gems", "marks" : 1})
questionsY6Spring.push({ "question" : "Aimee has counted her gems and made a table. How many more blue gems than orange gems does she have?", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "Aimee keeps her 8 purple gems in a separate jar. The purple gems and jar have a mass of 650g. When 2 purple gems are removed from the jar, the jar and the remaining gems have a mass of 530g. What is the mass of one purple gem? ", "answer" : "60", "type": 0, "units" : "grams", "marks" : 1})
questionsY6Spring.push({ "question" : "Scrambler sells 1 blue gem for £5. Scrambler also sells bags of 12 blue gems for £50. How much cheaper is it to buy a bag of gems rather than 12 single gems? ", "answer" : "10", "type": 0, "units" : "£", "marks" : 1})
questionsY6Spring.push({ "question" : "Emile needs to fly around a rocket ship. He gets 3/4 of the way around the rocket ship, but has another 24km left to fly! What is the total distance around the rocket ship in metres?", "answer" : "96000", "type": 0, "units" : "metres", "marks" : 1})
questionsY6Spring.push({ "question" : "Given that n = 10,  what is the value of 4n +5?", "answer" : "45", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "Given that 3m + 4 = 22, what is the value of m?", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY6Spring.push({ "question" : "Aimee thinks of a number. She divides the number by 4 and then adds 6. Her answer is 9. What number did Aimee think of? ", "answer" : "12", "type": 0, "units" : "", "marks" : 1})

  

//above is questions section
  
  const [questions, setQuestions] = useState([]);
  console.log(props);

  var timer = -1;

  //SET TIMER BASED ON THESE
  if (status == false){
    currQuestion = [];
    questionNum = 0;
    useranswers = [];
    shuffledAnswers = [];
    //check what questions it is, checking year first will check terms later like Spring etc
    if (props.assessment_type[0] == "1"){
      timer = -1;
      setQuestions(questionsY1Spring);
    } else if (props.assessment_type[0] == "2"){
      timer = -1;
      setQuestions(questionsY2Spring);
    } else if (props.assessment_type[0] == "3"){
      timer = 2100;
      setQuestions(questionsY3Spring);
    } else if (props.assessment_type[0] == "4"){
      timer = 3000;
      setQuestions(questionsY4Spring);
    } else if (props.assessment_type[0] == "5"){
      timer = 3000;
      setQuestions(questionsY5Spring);
    } else if (props.assessment_type[0] == "6"){
      timer = 3000;
      setQuestions(questionsY6Spring);
    }
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
      shuffledAnswers.push("");
      //DO SHUFFLE QUESTIONS
      if (questions[i].type == 1 || questions[i].type == 4){
        let choices = questions[i].answer.split("|");
        choices = shuffleArray(choices);
        console.log("CHOICES");
        console.log(choices);
        shuffledAnswers[i] = choices;
      }
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }

  /*
  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 999;
  }*/

  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  function MultipleButtons() {
    console.log(currentQuestion);
    return "blank"
    

  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    let requireString = "Year"+props.assessment_type[0];
    if (props.assessment_type[3] == "ar"){
      requireString+= "/ARSpringEnd";
    }else if (props.assessment_type[3] == "re"){
      requireString+= "/RESpringEnd";
    }
    requireString += "/year"+props.assessment_type[0]+"question"+(questionNum+1)+".png";
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer == youranswer){
        return true;
      }else{
        return false;
      }
    }else{
      let correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     let correct = 0;      
    let questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    let topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
   function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //if the user presses a multichoice button
  function PressMulti(value) {
    useranswers[questionNum] = value;
    setRefresh(!refresh);
  }

  function MultichoiceButtons(){
    let choices = shuffledAnswers[questionNum];
    console.log(shuffledAnswers);
    console.log(choices);

    return (
    <div>
       {choices.map(answer => {
        if(useranswers[questionNum] == "" || answer != useranswers[questionNum]){
          return (
            <MButton
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer} />}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => PressMulti(answer)}
          >
              <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                  {answer}
                </Textfit>
              </div>
          </MButton>
         )}
        return (
          <MButtonSelected
          {...console.log("SELECTED")}
          value={<div dangerouslySetInnerHTML={answer} />}
          style={{ flex: 1, margin: "20px" }}
          onClick={() => PressMulti(answer)}
        >
            <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                {answer}
              </Textfit>
            </div>
        </MButtonSelected>
        )
      })}
    </div>
    )
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="extrascaling">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >
            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                {currQuestion.type == 4 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }  
                        </div>
                    </div>
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                  <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
        </div>
        </div>
      </PracticeGame>
    </>
  );
}

const MultiChoiceContainer = styled.div`
  position: relative;
  top: 50%;
  right: 20%;
`

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Marks = styled.div`
      font-size: 4em;
      position: relative;
      right: 33%;
      top: 73%;
    `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const MButton = styled.div`
    text-align: center;
    width: 350px;
    height: 150px;
    margin: 5px;
    color: #fff;

    background: linear-gradient(
      0deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(225, 225, 225, 1) 100%
    );
    border: 2px solid #fff;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
  `;

  const MButtonSelected = styled.div`
  text-align: center;
  width: 350px;
  height: 150px;
  margin: 5px;
  color: #fff;
  background: linear-gradient(
    0deg,
    rgba(200, 200, 120, 1) 0%,
    rgba(225, 225, 100, 1) 100%
  );
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

const NavigationButton = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
right: -1000px;
top: 150px
background-image: url(${next});
color: #000;
user-select: none;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

const NavigationButtonBack = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
top: 150px;
right: 1000px
background-image: url(${back});
color: #000;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`